export default __webpack_public_path__ + "static/media/048-rudder.17f9702e.png";